import { CHECKOUT_STATE_ADVANCE, CHECKOUT_STATE_CHANGE } from 'actions/CheckoutActions/checkoutVisualStateActions';
import { CHECKOUT_SUMMARY_CLEAR } from 'actions/CheckoutActions/checkoutSummaryActions';
import { GET_USER_STATE_SUCCESS } from 'actions/userStateActions';
import get from 'lodash/get';

const INITIAL_STATE = {
	login: 'EXPANDED',
	address: 'COLLAPSED',
	orderSummary: 'COLLAPSED',
	payment: 'COLLAPSED'
};

function getCurrentExpanded(state) {
	return Object.keys(state).filter(section => state[section] === 'EXPANDED')[0];
}

export default function checkoutVisualState(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case CHECKOUT_STATE_ADVANCE:
			const currentExpanded = getCurrentExpanded(state);

			if (currentExpanded === 'login') {
				return { ...state, login: 'COMPLETED', address: 'EXPANDED' };
			} else if (currentExpanded === 'address' && state.login === 'COMPLETED') {
				return { ...state, address: 'COMPLETED', orderSummary: 'EXPANDED' };
			} else if (currentExpanded === 'orderSummary' && state.login === 'COMPLETED' && state.address === 'COMPLETED') {
				return { ...state, orderSummary: 'COMPLETED', payment: 'EXPANDED' };
			}
			return INITIAL_STATE;

		case CHECKOUT_STATE_CHANGE:
			const section = action.visualState;
			const override = action.override;

			if (section === 'login' && (state.login === 'COMPLETED' || override)) {
				return INITIAL_STATE;
			} else if (
				section === 'address' &&
				((state.login === 'COMPLETED' && state.address === 'COMPLETED') || override)
			) {
				return { login: 'COMPLETED', address: 'EXPANDED', orderSummary: 'COLLAPSED', payment: 'COLLAPSED' };
			} else if (
				section === 'orderSummary' &&
				((state.login === 'COMPLETED' && state.address === 'COMPLETED' && state.orderSummary === 'COMPLETED') ||
					override)
			) {
				return { login: 'COMPLETED', address: 'COMPLETED', orderSummary: 'EXPANDED', payment: 'COLLAPSED' };
			} else if (
				section === 'payments' &&
				((state.login === 'COMPLETED' && state.address === 'COMPLETED' && state.orderSummary === 'COMPLETED') ||
					override)
			) {
				return { login: 'COMPLETED', address: 'COMPLETED', orderSummary: 'COMPLETED', payment: 'EXPANDED' };
			}
			return INITIAL_STATE;

		case GET_USER_STATE_SUCCESS:
			if (get(action, ['data', 'SESSION', 'isLoggedIn'])) {
				return {
					login: 'COMPLETED',
					address: state.address === 'COMPLETED' ? 'COMPLETED' : 'EXPANDED',
					orderSummary: state.orderSummary === 'EXPANDED' ? 'EXPANDED' : 'COLLAPSED',
					payment: 'COLLAPSED'
				};
			}
			return INITIAL_STATE;
		case CHECKOUT_SUMMARY_CLEAR:
			if (action.isLoggedIn) {
				return { login: 'COMPLETED', address: 'EXPANDED', orderSummary: 'COLLAPSED', payment: 'COLLAPSED' };
			}
			return INITIAL_STATE;
		case 'BUY_EGV_REQUEST':
			return { login: 'COMPLETED', address: 'COMPLETED', orderSummary: 'EXPANDED', payment: 'COLLAPSED' };
	}
	return state;
}
